import React, { useRef, useState } from 'react';
import Card from '@components-clean/core/card';
import CreatedUpdatedInfo from '@components-clean/core/created-updated-info';
import EditCard from '@components-clean/core/edit-card';
import FilterList, { FilterListDataHandle } from '@components-clean/core/filter-list';
import { FilterListDataItem } from '@components-clean/core/filter-list/filter-list-item';
import { useBoolean, useTranslation } from '@hooks/index';

const testData = [
    {
        id: 1,
        labelText: 'Label 1',
        fieldKey: 'Field.1',
        fieldName: 'Field1',
        isEdit: false,
        isDisabled: true,
    },
    {
        id: 2,
        labelText: 'Label 2',
        fieldKey: 'Field.2',
        fieldName: 'Field2',
        isEdit: false,
        isDisabled: true,
    },
    {
        id: 3,
        labelText: 'Label 3',
        fieldKey: 'Field.3',
        fieldName: 'Field3',
        isEdit: false,
        isDisabled: true,
    },
];

// Alternative data
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const selectDummyData = ['Field.1', 'Field.2', 'Field.3', 'Field.4', 'Field.5'];

const selectDummyDataObjects = [
    { id: 1, value: 'Field.1' },
    { id: 2, value: 'Field.2' },
    { id: 3, value: 'Field.3' },
    { id: 4, value: 'Field.4' },
    { id: 5, value: 'Field.5' },
];

const FilterListPage = () => {
    const siteRef = useRef<FilterListDataHandle>(null);

    const { t }: { t: (key: string) => string } = useTranslation();

    const [siteFilters, setSiteFilters] = useState<FilterListDataItem[]>(testData);

    const isEdit = useBoolean(false);

    const onSave = () => {
        if (siteRef.current) {
            const childData = siteRef.current.getFiltersData();
            /* eslint-disable-next-line no-console */
            console.log('Site Data:', childData);
            setSiteFilters(
                childData.map((item) => ({
                    ...item,
                    isEdit: false,
                    isDisabled: true,
                })),
            );
        }

        isEdit.setFalse();
    };

    const onCancel = () => {
        setSiteFilters(siteFilters.map((item) => ({ ...item })));
        isEdit.toggle();
    };

    return (
        <EditCard
            title={t('admin:siteSubjectFilters')}
            data-testid="site-subject-filter-card"
            className="!k-w-2/3"
            isEditMode={isEdit.value}
            onEdit={isEdit.toggle}
            onSave={onSave}
            onCancel={onCancel}
            headerInfo={
                <CreatedUpdatedInfo created="01-JAN-2024 by Tom Smith" updated="01-JAN-2024 by Tom Smith" inline />
            }
        >
            <Card title={t('admin:siteFilters')} data-testid="site-filter-card">
                <FilterList
                    ref={siteRef}
                    data={siteFilters}
                    isEdit={isEdit.value}
                    selectData={selectDummyDataObjects}
                    displayField="value"
                    valueField="id"
                />
            </Card>
        </EditCard>
    );
};

export default FilterListPage;
